import { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: "e1afbeda-d7d9-4d0c-a4ef-d8f63e0a83d6",
    authority:
      "https://login.microsoftonline.com/dfce2170-64d6-4898-aa99-7886bd1f2170",
    redirectUri: `${window.location.origin}/`,
    postLogoutRedirectUri: `${window.location.origin}/signin`,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0:
            console.error(message);
            return;
          case 1:
            console.warn(message);
            return;
          case 2:
            console.info(message);
            return;
          case 3:
            console.debug(message);
            return;
          default:
            console.log(message);
            return;
        }
      },
      logLevel: 3,
    },
  },
};

export const loginRequest = {
  scopes: ["api://d0d1836c-d51d-4f43-9eee-1d6a58885b8a/.default"],
};
